import React from "react";

import { Grid, Box, Paper, Typography, Container } from "@mui/material";
import { Link } from "react-router-dom";
//import Paper from '@mui/material/Paper';
//import Grid from '@mui/material/Grid';

const Header = () => {
  return (
    <>
      <Grid container className="footer" py={4} bgcolor="#fbfbfb">
        <Container maxWidth="lg">
          <Grid container className="footer_links">
            <Link to="/privacy-policy" underline="none" mx={2}>
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" underline="none" mx={2}>
              Terms & Conditions
            </Link>
            <Link to="/faqs" underline="none" mx={2}>
              FAQ
            </Link>
            <Link to="/contact-us" underline="none" mx={2}>
              Contact Us
            </Link>

          </Grid>
        </Container>
      </Grid>
    </>
  );
};

export default Header;
